import React, { useEffect, useState } from "react";
import "./style.css";
import CustomCard from "../../../../dentail-indetifcation/components/d-reusable/CustomCard";
import { assessmentIcons } from "../../../utils/assessmentIcons";
import { Col, Row, Table } from "antd";
import CustomPrimaryButton from "../../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import CustomDrawer from "../../../../dentail-indetifcation/components/d-reusable/CustomDrawer";
import CaseReport from "./child/CaseReport";
import { useLocation, useNavigate } from "react-router-dom";
import { getCollaborationsCaseDetails } from "../../../../components/https/age-assessment-apis";
import {
  ageAssessmentBasePath,
  errorRequestHandel,
  formateDateAndTime,
  getDentalAge,
} from "../../../../helper";
import CustomSpinner from "../../../../dentail-indetifcation/components/d-reusable/CustomSpiner";
import { useDispatch, useSelector } from "react-redux";
import {
  _onClearCurrentCaseDetails,
  _onSetCurrentCaseDetails,
} from "../../../../redux/actions/age-assessment/caseRegistrationAction";
import CustomCardWithHeader from "../../../../components/custom-card-with-header/CustomCardWithHeader";
import { processFinalResult } from "../../../../utils/dentalIdHelper";
import { getDMRFromSubjectData } from "../../../../utils/dmrAgeRangeHelper";

const CaseDetails = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [biologicalAgeData, setBiologicalAgeData] = useState(null);
  const [dmrAgeRange, setDmrAgeRange] = useState("");
  const location = useLocation();
  const id = location.state?.projectId; // Get caseId from state
  const { metaData } = useSelector((state) => state.general);

  useEffect(() => {
    getCaseDetails();
  }, []);

  const getCaseDetails = async () => {
    try {
      setLoading(true);
      const response = await getCollaborationsCaseDetails({ id });

      if (response.status === 200) {
        const originalData = response.data.data;

        const mapToISO = (toothIds) =>
          toothIds.map(
            (id) => metaData.teeth.find((tooth) => tooth.id == id)?.iso
          );

        // Create a deep copy so we don't mutate original response
        const updatedCaseDetails = {
          ...originalData,
          missing_teeth: mapToISO(originalData.missing_teeth || []),
          decayed_teeth: mapToISO(originalData.decayed_teeth || []),
          restored_teeth: mapToISO(originalData.restored_teeth || []),
          present_teeth: mapToISO(originalData.present_teeth || []),
        };

        // Update state and dependent values
        setData(updatedCaseDetails);
        setDmrAgeRange(getDMRFromSubjectData(updatedCaseDetails));

        if (
          updatedCaseDetails?.collaborators?.length > 0 &&
          updatedCaseDetails?.collaborators[0]
        ) {
          const result = processFinalResult(
            updatedCaseDetails?.collaborators[0],
            updatedCaseDetails
          );
          setBiologicalAgeData(result);
        }

        dispatch(_onClearCurrentCaseDetails());
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  const handleShortReport = () => {
    const pdfUrl = `${process.env.REACT_APP_PDF_URL}/projects/pdf/${id}?report_type=short`;
    window.open(pdfUrl, "_blank"); // Opens in a new tab
  };

  return (
    <div className="case_details_container">
      <CustomSpinner loading={loading} />
      <CustomCard>
        <div className="case_details_info">
          <img src={assessmentIcons.caseIcon} />
          <div>
            <p>Application No #</p>
            <span>{data?.case_number}</span>
          </div>
        </div>
      </CustomCard>
      <br />
      <CustomCardWithHeader
        title={"Subject Information"}
        isLink={true}
        onClick={() => setIsOpen(true)}
      >
        <div className="case_details_subject_info">
          <Row>
            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Name</p>
                <span className="value">{data?.full_name}</span>
              </div>
            </Col>

            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Status</p>
                <span className="value">{data?.subject_status}</span>
              </div>
            </Col>

            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Referring Agency</p>
                <span className="value">
                  {data?.referring_agency ? data?.referring_agency : "-"}
                </span>
              </div>
            </Col>
            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Stated Age</p>
                <span className="value">
                  {/* {data?.stated_age && formateDateAndTime(data?.date, "d MMM yyyy")} |{"  "}
                  {data?.stated_age ? data?.stated_age : "-"} */}
                  {data?.stated_age && data?.date
                    ? `${formateDateAndTime(data.date, "DD MMMM YYYY")} - ${
                        data.stated_age
                      }`
                    : data?.date
                    ? formateDateAndTime(data.date, "DD MMMM YYYY")
                    : data?.stated_age
                    ? data.stated_age
                    : "-"}
                </span>
              </div>
            </Col>
            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Biological Sex</p>
                <span className="value">{data?.gender}</span>
              </div>
            </Col>
            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Ancestry</p>
                <span className="value">
                  {data?.ethnicity ? data?.ethnicity : "-"}
                </span>
              </div>
            </Col>

            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">Purpose of Assessment </p>
                <span className="value">{data?.purpose_of_assessment}</span>
              </div>
            </Col>
            <Col md={6}>
              <div className="case_details_subject_details">
                <p className="key">DMR Age</p>
                <span className="value">{dmrAgeRange ? dmrAgeRange : "-"}</span>
              </div>
            </Col>
          </Row>
        </div>
      </CustomCardWithHeader>

      <br />

      {data?.collaborators?.length > 0 &&
      data?.collaborators[0]?.results.length > 0 ? (
        <>
          <CustomCard>
            <div className="case_details_result_info">
              <h4>Age Estimation</h4>

              <Row gutter={[16, 16]}>
                <Col md={8}>
                  <div className="case_details_result_details">
                    <p>Biological Age</p>
                    <span>{biologicalAgeData?.biologicalAge || "Unknown"}</span>
                  </div>
                </Col>
                <Col md={8}>
                  <div
                    className="case_details_result_details"
                    style={{ borderLeftColor: "#F5B46B" }}
                  >
                    <p>Biological DOB</p>
                    <span>{biologicalAgeData?.biologicalDob}</span>
                  </div>
                </Col>
                <Col md={8}>
                  <div
                    className="case_details_result_details"
                    style={{ borderLeftColor: "#FF6F6F" }}
                  >
                    <p>Biological Range</p>
                    <span>{biologicalAgeData?.biologicalAgeRange}</span>
                  </div>
                </Col>
              </Row>
            </div>
          </CustomCard>
          <br />
          <CustomCard>
            <div className="case_details_table_info">
              {/* <h4>Method-Specific Results</h4> */}
              <Table
                dataSource={data?.collaborators[0]?.results}
                style={{ overflowX: "scroll" }}
                rowClassName={(record, index) =>
                  record?.is_mac === 1 ? "blue-row" : ""
                }
                pagination={false}
                columns={[
                  {
                    title: "Method Name",
                    // dataIndex: "name",
                    key: "method",
                    width: "45%",
                    render: (text, record, index) => (
                      <div>
                        {record?.method}{" "}
                        {record?.is_mac === 1 && (
                          <img
                            src={assessmentIcons.caseStar}
                            alt="Case Star Icon"
                            className="green_mac_icon"
                          />
                        )}
                      </div>
                    ),
                  },
                  {
                    title: "Mean",
                    key: "age",
                    // dataIndex: "age",
                    onCell: (_, rowIndex) => ({
                      className: `column-${5}`,
                    }),
                    onHeaderCell: () => ({
                      // className: `column-${5}`,
                    }),
                    render: (text, record) => record?.age + " " + "Years",
                  },

                  {
                    title: "Deviation",
                    key: "standard_deviation",
                    onCell: (_, rowIndex) => ({
                      className: `column-${5}`,
                    }),
                    onHeaderCell: () => ({
                      // className: `column-${5}`,
                    }),
                    render: (text, record) =>
                      "+/-" + " " + record?.standard_deviation + " " + "Years",
                  },
                  {
                    title: "Range",
                    key: "range",
                    dataIndex: "range",
                    onCell: (_, rowIndex) => ({
                      className: `column-${5}`,
                    }),
                    onHeaderCell: () => ({
                      // className: `column-${5}`,
                    }),
                    render: (text, record) =>
                      `${(record.age - record.standard_deviation).toFixed(
                        2
                      )} - ${(record.age + record.standard_deviation).toFixed(
                        2
                      )} Years`,
                  },
                ]}
              />
            </div>
          </CustomCard>
        </>
      ) : (
        <CustomCardWithHeader title={"Result"}>
          <div className="case_details_no_result">
            <div className="case_details_no_result_info">
              <img src={assessmentIcons.noresult} />
              <p>Analysis not yet started.</p>
            </div>

            <CustomPrimaryButton
              title="Start Now"
              onClick={() => {
                dispatch(_onSetCurrentCaseDetails(data));
                navigate(`${ageAssessmentBasePath}/cases/age-group`);
              }}
              width={150}
            />
          </div>
        </CustomCardWithHeader>
      )}

      {data?.collaborators?.length > 0 &&
        data?.collaborators[0]?.results.length > 0 && (
          <>
            <br />
            <Row justify={"start"}>
              <CustomPrimaryButton
                title="View Report"
                onClick={handleShortReport}
              />
            </Row>
          </>
        )}

      <CustomDrawer
        width={500}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="Details"
      >
        <CaseReport caseDetails={data} />
      </CustomDrawer>
    </div>
  );
};

export default CaseDetails;
